import { render, staticRenderFns } from "./NewHolidaysComponent.vue?vue&type=template&id=45715e3d"
import script from "./NewHolidaysComponent.vue?vue&type=script&lang=js"
export * from "./NewHolidaysComponent.vue?vue&type=script&lang=js"
import style0 from "./NewHolidaysComponent.vue?vue&type=style&index=0&id=45715e3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports